import {AssetsContext} from "context/Assets.context";
import React from "react";
export const useAssets = () => React.useContext(AssetsContext)